import { type Comment } from "@generated/prisma/client"

import { useUserLookup } from "~/hooks/useUsers"
import { DateFormatType, formatDate } from "~/utils/datetime"

import { Card } from "../reusable/Card"
import { HoverCard, HoverCardContent, HoverCardTrigger } from "../reusable/hovercard/HoverCard"
import { CalendarBlank, Chat } from "@phosphor-icons/react"
import { getTailwindValue } from "~/utils/tailwind"

export const CommentsHoverCard = ({ comments }: { comments: Comment[] }) => {
  return (
    <HoverCard>
      <HoverCardTrigger>
        <div className="flex items-center justify-center">
          <Chat size="12" className="text-fg-muted" />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="bg-subtle text-fg-subtle px-3 py-2">
        <span className="text-fg-subtle text-sm font-medium">
          {comments.length} {comments.length > 1 ? "comments" : "comment"}
        </span>
        <div className="flex flex-col gap-2 mt-2">
          {comments.map((comment) => (
            <CommentCard key={comment.id} comment={comment} />
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}

export const CommentCard = ({ comment }: { comment: Comment }) => {
  const { getUserName } = useUserLookup()
  const displayName = getUserName(comment.userId) || comment.userName

  return (
    <Card key={comment.id} className="flex flex-col p-2 gap-1">
      <p className="text-base font-medium">{displayName}</p>
      <p className="text-sm text-fg-subtle">{comment.text}</p>
      <div className="flex items-center gap-1">
        <CalendarBlank size="12" color={getTailwindValue("--color-fg-subtle")} />
        <p className="text-xs text-fg-subtle">
          {formatDate(comment.createdAt, DateFormatType.FullDate)}
        </p>
      </div>
    </Card>
  )
}
